import { Plus } from '@phosphor-icons/react'
import { ButtonHTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  title?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

export const EditableBadgeAddButton = ({
  className,
  title = 'Add Tag',
  ...props
}: Props) => (
  <button
    className={cn(
      'flex items-center gap-1 rounded-md border !border-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-700 !outline-none hover:!border-gray-400/60 hover:bg-gray-50',
      className
    )}
    {...props}
  >
    <Plus className="text-sm" weight="bold" />
    {title}
  </button>
)
